<template>
<!-- 页头 -->
  <div class="top">
    <div class="box vue_flex">
      <i></i>
      <div class='img' @click="changeicon1()" v-if="icon == 1">
        <img src='@/assets/menu.png'/>
      </div>
      <div class='img1' v-if="icon == 2" @click="changeicon2()">
        <img src='@/assets/cha.png'/>
      </div>
    </div>
    
    <!-- 菜单抽屉 -->
    <el-drawer
      size='30%'
      :direction="direction"
      :visible.sync="drawer"
      :with-header="false"
      class='menu'
      :modal='false'
      :before-close="handleClose">
      <el-menu :default-active="$route.path" router active-text-color="#55A2FF">
        <el-menu-item index="/mobile"  @click="changeicon2($event)" >公司介绍</el-menu-item>
        <el-divider></el-divider>
        <el-menu-item index="/mobile/connect" @click="changeicon2($event)">联系我们</el-menu-item>
      </el-menu>
    </el-drawer>
  </div>
</template>

<script>
// 导入bus的模块对象
import bus from '@/utils/bus.js';
export default {
  data() {
    return {
      drawer: false,// 控制菜单是否出现
      direction:'ttb',// 控制菜单从左到右出现
      icon:'1',// 设置顶部图标的变化
    }
  },
  methods: {
    changeicon1() {
      this.drawer = true;
      this.icon = '2';
    },
    changeicon2(e) {
      this.drawer = false;
      this.icon = '1';
      // 兄弟传值 使得bus调用自己的事件(是大哥给bus声明的)
      // bus.$emit(事件，参数，参数)
      bus.$emit('jieshou', e.index);
    },
    handleClose() {
      this.drawer = false;
      this.icon = '1';
    }
  },
}
</script>

<style lang="scss" scoped>
.top{
  background-color: #3953DA;
  height: 60px;
  line-height: 60px;
  i{
    margin-left: -15px;
    align-self: center;
    width:130px;
    height:50px;
    align-self:center;// 垂直居中
    background-image: url("../assets/feedying-logo.svg");
    background-repeat: no-repeat;// 背景图不平铺
    background-size:cover;// 全覆盖
    background-position: center; //指定元素背景图片的位置
  }
  .img{
    // 菜单定位
    width:25px;
    line-height:60px;
    align-items: center;
    position:relative;
    top:10px;
    img{
      width:100%;
    }
  }
  .img1{
    // 菜单定位
    width:15px;
    line-height:60px;
    align-items: center;
    position:relative;
    top:3px;
    right:3px;
    img{
      width:100%;
    }
  }
  .menu{
    position:absolute;
    top:60px;
    border-top:1px solid #F2F2F2;
    height:400px;
    margin-top:-1px;
    // left:0;
    // overflow:hidden;
  }
}
.el-menu-item {
    color: #333333;
}
.el-divider--horizontal {
  margin: 0; 
  width: 90%;
  margin:auto;
}
</style>